import { projectPermission } from '@/middleware/permission';

export default [
  {
    path: '/dashboard/:id',
    name: 'dashboard',
    component: () => import('@/views/dashboard/DashBoard.vue'),
    meta: { type: 'dashboard', middleware: [projectPermission] },
  },
];
